// extracted by mini-css-extract-plugin
module.exports = {"wrap":"R_dt","phone":"R_dv","phone-link":"R_dw","phoneLink":"R_dw"};